module.exports = __webpack_public_path__ + "img/ca-horiz-negativo.8676e52f.svg";